/**
 * CSV in der deutschen Variante: Semikolon-getrennt (Excel-DE öffnet es ohne Import-Dialog), Zeilen mit
 * CRLF. Felder mit ; " oder Zeilenumbruch werden in Anführungszeichen gesetzt, enthaltene " verdoppelt.
 */
export function buildCsv(headers: readonly string[], rows: readonly (readonly string[])[]): string {
  const esc = (value: string): string => (/[";\r\n]/.test(value) ? `"${value.replace(/"/g, '""')}"` : value)
  const line = (cells: readonly string[]): string => cells.map(esc).join(';')
  return [line(headers), ...rows.map(line)].join('\r\n')
}

/**
 * v6-Formel-Injection-Guard (EINE Wahrheit für alle CSV-Exporte): Zellen, die — auch nach führendem
 * Whitespace, manche Tabellenkalkulationen trimmen vor der Auswertung — mit =, +, -, @ beginnen, bekommen
 * ein führendes Apostroph, sonst führt Excel/LibreOffice sie als Formel aus. Relevant überall, wo
 * Nutzer-Freitext exportiert wird (Korrektur-Gründe, Audit-detail, Namen).
 */
export function guardFormulaCell(cell: string): string {
  return /^\s*[=+\-@]/.test(cell) ? `'${cell}` : cell
}

const BOM = '﻿' // lässt Excel die UTF-8-Umlaute korrekt erkennen

/**
 * Löst einen Datei-Download aus (Blob + temporärer Anker, danach wieder freigegeben). Kein Inline-Script
 * oder -Style → bleibt unter der harten CSP zulässig.
 */
export function downloadTextFile(filename: string, text: string, type = 'text/csv;charset=utf-8'): void {
  const blob = new Blob([BOM + text], { type })
  const url = URL.createObjectURL(blob)
  const anchor = document.createElement('a')
  anchor.href = url
  anchor.download = filename
  anchor.click()
  URL.revokeObjectURL(url)
}
